import CATEGORY_ROUTES from '@/presentation/modules/category/constants/routes/index.js';

const categoryRoutes = [
	{
		name: CATEGORY_ROUTES.category.name,
		path: CATEGORY_ROUTES.category.path,
		component: CATEGORY_ROUTES.category.component,
		meta: CATEGORY_ROUTES.category.meta,
	},
	{
		name: CATEGORY_ROUTES.categoryItems.name,
		props: true,
		path: CATEGORY_ROUTES.categoryItems.path,
		component: CATEGORY_ROUTES.categoryItems.component,
	},
];

export default categoryRoutes;
